import{parseScope as e}from"./parse-scope.mjs";const t=t=>t?e(t).length===0:!0;export{t as isGlobalScope};
//# sourceMappingURL=is-global-scope.mjs.map